// Shared singleton AudioContext for in-app alert/notification sounds.
// Browsers create an AudioContext in a "suspended" state until a user gesture
// resumes it (autoplay policy). We keep a single shared context so it can be
// unlocked app-wide on the first interaction, regardless of which page created it.

let ctx = null;

export function getAlertAudioContext() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

export function unlockAlertAudio() {
  const c = getAlertAudioContext();
  if (c && c.state === 'suspended') {
    c.resume().catch(() => {});
  }
}
